// This file is generated by the command "yarn workspace @classify/illustrations build"
export default 'https://static.oc-static.com/illustrations/Error500-1.png';
